import { Component, OnInit, ViewChild } from '@angular/core';
import { FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { first } from 'rxjs/operators';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { TransitRequestDto } from 'src/app/front-user/services/e-booking/transit-request/transit-request.model';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';

@Component({
  selector: 'app-treasury-confirm-first-payment',
  templateUrl: './treasury-confirm-first-payment.component.html',
  styleUrls: ['./treasury-confirm-first-payment.component.css']
})
export class TreasuryConfirmFirstPaymentComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  treasuryFirstConfimPaymentForm: FormGroup;
  AntipollutionPaymentForm: FormGroup;
  displayedLang: Languages;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  submitted: boolean = false;
  user: User = new User();
  showRequest: boolean = false;
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();
  numberRegex: string = '^[0-9]*(?:\.[0-9]*)?$';
  error: any = { isError: false, errorMessage: '' };
  transitData: TransitRequestDto = new TransitRequestDto();
  responseObj: ResponseObject = new ResponseObject();

  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;

  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices, private route: ActivatedRoute, private router: Router,
    private translate: TranslateService, private adminSrv: TransitAdminService,
    private authenticationService: AuthenticationService, private alertService: AlertService, private transitSrv: TransitService) {

    this.displayedLang = this.globalSrv.getLanguage()
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }

    this.user = this.globalSrv.user;
    // this.baseRequestId = '43C1719C-46A9-4F28-AE3C-589AFE4542E3';

  }

  ngOnInit() {
    this.buildForm();
    this.buildAntipollutionForm();
    this.getAntipollutionData();
  }
  buildForm() {
    this.treasuryFirstConfimPaymentForm = this.formBuilder.group({
      IsAgentPayedFirst: ['', [Validators.requiredTrue]],
      ChequeNumber: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      TotalFees: new FormControl({ value: this.FeesEstimateObj.TotalFees, disabled: true }),
    });

  }

  buildAntipollutionForm() {
    this.AntipollutionPaymentForm = this.formBuilder.group({
      IsAgentPayedAntipollutionFees: new FormControl({value:'', disabled: true }),
      AntipollutionFees: new FormControl({value:'', disabled: true }),
      AntipollutionPaymentDate: new FormControl({value:'', disabled: true }),
    });
    this.AntipollutionPaymentForm.disable();
  }
  receiveFeesValue($event) {
    this.FeesEstimateObj = $event;
    if (this.baseRequestId && this.FeesEstimateObj) {
      this.treasuryFirstConfimPaymentForm.patchValue({
        TotalFees: this.FeesEstimateObj.TotalFees,
      });
    }
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        // if (this.requestStatus == ServiceStatus.PendingOnTransitDates) {
        this.formMode = FormMode.Add;
        this.treasuryFirstConfimPaymentForm.enable();
        this.treasuryFirstConfimPaymentForm.controls.TotalFees.disable();
        // }
        // else {
        //   this.getTransitRequest();
        // }
        if (history.state.data && history.state.data.isCompleted) {
          this.getTransitRequest();
        }
      }
    )
  }

  public getAntipollutionData() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          // Antipollution Payment Data
          this.AntipollutionPaymentForm.patchValue({
            IsAgentPayedAntipollutionFees: resObj.Data['AntipollutionFeesPaid'],
            AntipollutionFees: resObj.Data['AntipollutionPaymentValue'],
            AntipollutionPaymentDate: resObj.Data['AntipollutionPaymentDate']

          });
        }
      });
  }

  public getTransitRequest() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          this.treasuryFirstConfimPaymentForm.patchValue({
            IsAgentPayedFirst: this.transitData.IsAgentPayedFirst,
            ChequeNumber: this.transitData.ChequeNumber

          });
          this.formMode = FormMode.Readonly;
          this.treasuryFirstConfimPaymentForm.disable();

          // Antipollution Payment Data
          this.AntipollutionPaymentForm.patchValue({
            IsAgentPayedAntipollutionFees: resObj.Data['AntipollutionFeesPaid'],
            AntipollutionFees: resObj.Data['AntipollutionPaymentValue'],
            AntipollutionPaymentDate: resObj.Data['AntipollutionPaymentDate']

          });
        }
      });
  }

  get f() {
    return this.treasuryFirstConfimPaymentForm.controls;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.treasuryFirstConfimPaymentForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.adminDecisionObject = this.treasuryFirstConfimPaymentForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;
    this.adminDecisionObject.IsFirstConfirmedPayment = true;

    this.adminSrv.treasuryFirstConfirmPayment(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.treasuryFirstConfimPaymentForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));
          }

        });
  }

  onChangeChequeNumber(event) {

    let chequeNumber = event.target.value;
    let controls = this.treasuryFirstConfimPaymentForm.get('ChequeNumber');
    if (chequeNumber) {
      this.adminSrv.checkDuplicateChequeNumber(chequeNumber).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          //this.error = { isError: true, errorMessage: this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]) };
          controls.setErrors({ duplicatedNumber: true });
        }
        else {
          //this.error = { isError: false, errorMessage: '' };
          controls.setErrors(null);
          controls.setValidators([Validators.required, CustomValidators.textSpaceValidator()]);
          controls.updateValueAndValidity();
        }

      });
    }

  }
}
